import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box} from '@mui/material'
import {Nullable} from '../../../../../app/TypeHelpers'
import {
    NatBeforeContactAddress,
    NatContactInformation,
    NatDestinationContactAddress,
    NatGuestOwnershipTransferNewMemberLocationState,
    NatPaymentContactAddress,
    NatProxyContactAddress,
    NatSharer,
} from './NatGuestOwnershipTransferNewMemberInterface'
import {ItemHeading, WideWhiteArea} from '../../../applications/common/resident/NatResidentApplicationsCommon'
import NatGuestOwnershipTransfersDetailFormItem from '../../common/NatGuestOwnershipTransfersDetailFormItem'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import {FlexContainer, FullWidthColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {BlockSpacer, currentMedia} from '../../../../../styledComponents/ResponsiveConvenience'
import {DefaultStyledButton} from '../../../../../styledComponents/Button'
import PPRadioGroupForGuest from '../../../../../components/shared/forms/guest/PPRadioGroupForGuest'
import {DESTINATION_EXISTENCE, PAYMENT_EXISTENCE, RENT_EXISTENCE, RESIDENT_PLACE} from '../../../../../CodeMaster'

import {NatPutNewMemberRequest} from '../../repository/NatPutNewMemberRequest'
import ErrorMessageAreaWrapper from '../../../../../components/shared/forms/resident/ErrorMessageAreaWrapper'
import {NatZipCode} from '../../../condominium/repository/NatZipCode'
import {RequestItemError} from '../../../../../network/response/RequestItemError'
import {Messages} from '../../../../../Messages'
import {PPTextAreaForResident} from '../../../../../components/shared/forms/resident/PPTextAreaForResident'
import NatCurrentDateTimeRepo from '../../../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatCondominiumRepo from '../../../condominium/repository/NatCondominiumRepo'
import HolidaysRepository from '../../../../../components/HolidaysRepository'
import PPDatePickerForResident from '../../../../../components/shared/forms/resident/PPDatePickerForResident'
import {HKConstants} from '../../../../../HKConstants'
import moment from 'moment'
import {NatGetCurrentDateTime} from '../../../currentDateTime/repository/NatGetCurrentDateTime'
import {DisplayItemInputTitleRequiredNoMargin} from '../../../../../styledComponents/DisplayItem'
import {FontSize} from '../../../../../styledComponents/Constants'
import styled from 'styled-components'
import {GuestApplyButton} from '../../common/NatOwnershipTransfersCommon'
import {GuestWithErrorHandlingPagePropsSet} from '../../../../../components/shared/hoc/createGuestWithErrorHandlingPage'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    currentDateTimeRepo: NatCurrentDateTimeRepo
    condominiumRepo: NatCondominiumRepo
    holidaysRepo: HolidaysRepository
    navigate: NavigateFunction
    location: Location<NatGuestOwnershipTransferNewMemberLocationState>
    applyId?: string

    familyName: Nullable<string>
    firstName: Nullable<string>
    familyNameKana: Nullable<string>
    firstNameKana: Nullable<string>
    mailAddress: Nullable<string>
    mailAddressConfirm: Nullable<string>
    sharerList: Nullable<NatSharer[]>
    residentPlace: Nullable<string>
    moveInDate: Nullable<string>
    contactInformation: Nullable<NatContactInformation>
    beforeContactAddress: Nullable<NatBeforeContactAddress>
    proxyContactAddress: Nullable<NatProxyContactAddress>
    rentExistence: Nullable<string>
    paymentExistence: Nullable<string>
    paymentContactAddress: Nullable<NatPaymentContactAddress>
    destinationExistence: Nullable<string>
    destinationContactAddress: Nullable<NatDestinationContactAddress>

    submitButtonLabel: string
    onClickApplyConfirmButton: (request: NatPutNewMemberRequest) => Promise<void>
}

interface State {
    moveInDate: string
    contactInformation: NatContactInformation
    beforeContactAddress: NatBeforeContactAddress
    proxyContactAddress: NatProxyContactAddress
    rentExistence: string
    paymentExistence: string
    paymentContactAddress: NatPaymentContactAddress
    destinationExistence: string
    destinationContactAddress: NatDestinationContactAddress

    holidays: string[]

    applyButtonDisabled: boolean
    isLoadCompleted: boolean
}

interface Address {
    prefecture: string
    address2: string
    address3: string
}

export default class NatGuestNewMemberPageForm
    extends Component<Props & GuestWithErrorHandlingPagePropsSet, State> {

    constructor(props: Readonly<Props & GuestWithErrorHandlingPagePropsSet>) {
        super(props)

        this.state = {
            moveInDate: '',
            contactInformation: {
                contactPhoneNumber: null,
                contactAddress: null,
                contactZipCode: null,
                contactPrefecture: null,
                contactAddress2: null,
                contactAddress3: null,
                contactBuildingRoomNumber: null,
            },
            beforeContactAddress: {
                beforeContactPhoneNumber: null,
                beforeContactZipCode: null,
                beforeContactPrefecture: null,
                beforeContactAddress2: null,
                beforeContactAddress3: null,
                beforeContactBuildingRoomNumber: null,
            },
            proxyContactAddress: {
                proxyContactRelationship: null,
                proxyContactFamilyName: null,
                proxyContactFirstName: null,
                proxyContactPhoneNumber: null,
                proxyContactZipCode: null,
                proxyContactPrefecture: null,
                proxyContactAddress2: null,
                proxyContactAddress3: null,
                proxyContactBuildingRoomNumber: null,
            },
            rentExistence: '',
            paymentExistence: '0',
            paymentContactAddress: {
                paymentRelationship: null,
                paymentName: null,
                paymentPhoneNumber: null,
                paymentZipCode: null,
                paymentPrefecture: null,
                paymentAddress2: null,
                paymentAddress3: null,
                paymentBuildingRoomNumber: null,
            },
            destinationExistence: '0',
            destinationContactAddress: {
                destinationName: null,
                destinationPhoneNumber: null,
                destinationZipCode: null,
                destinationPrefecture: null,
                destinationAddress2: null,
                destinationAddress3: null,
                destinationBuildingRoomNumber: null,
            },
            holidays: [],
            applyButtonDisabled: true,
            isLoadCompleted: false,
        }

        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleChangeRentExistence = this.handleChangeRentExistence.bind(this)
        this.handleChangePaymentExistence = this.handleChangePaymentExistence.bind(this)
        this.handleMoveInDate = this.handleMoveInDate.bind(this)
        this.handleChangeDestinationExistence = this.handleChangeDestinationExistence.bind(this)
        this.handleChangeContactInformationText = this.handleChangeContactInformationText.bind(this)
        this.handleChangeBeforeContactAddressText = this.handleChangeBeforeContactAddressText.bind(this)
        this.handleChangeProxyContactAddressText = this.handleChangeProxyContactAddressText.bind(this)
        this.handleChangePaymentAddressText = this.handleChangePaymentAddressText.bind(this)
        this.handleChangeDestinationAddressText = this.handleChangeDestinationAddressText.bind(this)
        this.getAddressFromZipCode = this.getAddressFromZipCode.bind(this)
        this.getContactInformationFromZipCode = this.getContactInformationFromZipCode.bind(this)
        this.getBeforeContactAddressFromZipCode = this.getBeforeContactAddressFromZipCode.bind(this)
        this.getProxyContactAddressFromZipCode = this.getProxyContactAddressFromZipCode.bind(this)
        this.getPaymentAddressFromZipCode = this.getPaymentAddressFromZipCode.bind(this)
        this.getDestinationAddressFromZipCode = this.getDestinationAddressFromZipCode.bind(this)
        this.updateApplyConfirmButtonDisabled = this.updateApplyConfirmButtonDisabled.bind(this)
        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const [currentTimeResponse, holidays] = await Promise.all([
                this.getCurrentDateTime(),
                this.getHoliday(),
            ])

            const moveInDate = this.props.moveInDate ?? this.state.moveInDate
            const contactInformation = this.props.contactInformation ?? this.state.contactInformation
            const beforeContactAddress = this.props.beforeContactAddress ?? this.state.beforeContactAddress
            const proxyContactAddress = this.props.proxyContactAddress ?? this.state.proxyContactAddress
            const rentExistence = this.props.rentExistence ?? this.state.rentExistence
            const paymentExistence = this.props.paymentExistence ?? this.state.paymentExistence
            const paymentContactAddress = this.props.paymentContactAddress ?? this.state.paymentContactAddress
            const destinationExistence = this.props.destinationExistence ?? this.state.destinationExistence
            const destinationContactAddress =
                this.props.destinationContactAddress ?? this.state.destinationContactAddress

            this.setState({
                moveInDate: moveInDate,
                contactInformation: contactInformation,
                beforeContactAddress: beforeContactAddress,
                proxyContactAddress: proxyContactAddress,
                rentExistence: rentExistence,
                paymentExistence: paymentExistence,
                paymentContactAddress: paymentContactAddress,
                destinationExistence: destinationExistence,
                destinationContactAddress: destinationContactAddress,
                holidays: holidays === null ? [] : holidays,
            })


        } finally {
            this.setState({isLoadCompleted: true},
                () => this.updateApplyConfirmButtonDisabled())
            this.props.eventEmitter.closeLoading()
        }
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, eventEmitter} = this.props

        return await this.props.asyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    async getHoliday(): Promise<Nullable<string[]>> {
        const {holidaysRepo, eventEmitter} = this.props

        const minDate: string = HKConstants.CMN.SYC.MIN_HOLIDAY_DATE
        const maxDate: string = HKConstants.CMN.SYC.MAX_HOLIDAY_DATE
        return await this.props.asyncCallFunction(
            holidaysRepo.getHolidays.bind(holidaysRepo, minDate, maxDate),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    handleMoveInDate(date: string): void {
        this.setState({moveInDate: date}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
        const initBeforeContactAddress =
            (date < moment(this.props.location.state.ownershipTransferDate)
                .clone().add(60, 'days').format('YYYY-MM-DD'))
        if (initBeforeContactAddress) {
            this.setState({
                beforeContactAddress: {
                    beforeContactPhoneNumber: null,
                    beforeContactZipCode: null,
                    beforeContactPrefecture: null,
                    beforeContactAddress2: null,
                    beforeContactAddress3: null,
                    beforeContactBuildingRoomNumber: null,
                },
            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        }
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeRentExistence(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            rentExistence: event.target.value,
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangePaymentExistence(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            paymentExistence: event.target.value,
            paymentContactAddress: {
                paymentRelationship: null,
                paymentName: null,
                paymentPhoneNumber: null,
                paymentZipCode: null,
                paymentPrefecture: null,
                paymentAddress2: null,
                paymentAddress3: null,
                paymentBuildingRoomNumber: null,
            },
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeDestinationExistence(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            destinationExistence: event.target.value,
            destinationContactAddress: {
                destinationName: null,
                destinationPhoneNumber: null,
                destinationZipCode: null,
                destinationPrefecture: null,
                destinationAddress2: null,
                destinationAddress3: null,
                destinationBuildingRoomNumber: null,
            },
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeContactInformationText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, contactInformation: {...this.state.contactInformation, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeBeforeContactAddressText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, beforeContactAddress: {...this.state.beforeContactAddress, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeProxyContactAddressText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, proxyContactAddress: {...this.state.proxyContactAddress, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangePaymentAddressText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, paymentContactAddress: {...this.state.paymentContactAddress, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeDestinationAddressText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        this.setState({
            ...this.state, destinationContactAddress: {...this.state.destinationContactAddress, [key]: value},
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getAddressFromZipCode(zipCode: string | null, resultCode: string): Promise<Nullable<Address>> {
        const {condominiumRepo} = this.props
        let address: Nullable<Address> = null

        if (!zipCode) {
            const requestItemError = new RequestItemError(
                resultCode, Messages.ECONA0001.toString(), 'ECONA0001')
            this.props.eventEmitter.emit(resultCode, requestItemError)
            return address
        }
        await this.props.eventEmitter.showLoading()

        try {
            // 桁数不正の場合、単純に結果が取得できないので特に事前チェックは行わない
            const firstPart = zipCode.substring(0, 3)
            const lastPart = zipCode.substring(3, zipCode.length)

            await condominiumRepo.getZipCode(firstPart, lastPart).then(
                zipData => {
                    const zipCodeResponse: NatZipCode = zipData

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data[0] && zipCodeResponse.data[0].ja) {
                        address = {
                            prefecture: zipCodeResponse.data[0].ja.prefecture,
                            address2: zipCodeResponse.data[0].ja.address1,
                            address3: zipCodeResponse.data[0].ja.address2,
                        }
                    }

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data.length > 1) {
                        const requestItemError = new RequestItemError(
                            'zipCode', Messages.WCONA0002.toString(), 'WCONA0002')
                        this.props.eventEmitter.emit(resultCode, requestItemError)

                    }
                },
            ).catch(
                () => {
                    const requestItemError = new RequestItemError(
                        resultCode, Messages.ECONA0001.toString(), 'ECONA0001')
                    this.props.eventEmitter.emit(resultCode, requestItemError)
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
        return address
    }

    async getContactInformationFromZipCode(): Promise<void> {
        const contactInformation = this.state.contactInformation

        const address: Nullable<Address> = await this.getAddressFromZipCode(contactInformation.contactZipCode, 'contactInformation.contactZipCode')
        if (address) {
            contactInformation.contactPrefecture = address.prefecture
            contactInformation.contactAddress2 = address.address2
            contactInformation.contactAddress3 = address.address3
        }
        this.setState({contactInformation: contactInformation}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getBeforeContactAddressFromZipCode(): Promise<void> {
        const beforeContactAddress = this.state.beforeContactAddress

        const address: Nullable<Address> = await this.getAddressFromZipCode(beforeContactAddress.beforeContactZipCode, 'beforeContactAddress.beforeContactZipCode')
        if (address) {
            beforeContactAddress.beforeContactPrefecture = address.prefecture
            beforeContactAddress.beforeContactAddress2 = address.address2
            beforeContactAddress.beforeContactAddress3 = address.address3
        }
        this.setState({beforeContactAddress: beforeContactAddress}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getProxyContactAddressFromZipCode(): Promise<void> {
        const proxyContactAddress = this.state.proxyContactAddress

        const address: Nullable<Address> = await this.getAddressFromZipCode(proxyContactAddress.proxyContactZipCode, 'proxyContactAddress.proxyContactZipCode')
        if (address) {
            proxyContactAddress.proxyContactPrefecture = address.prefecture
            proxyContactAddress.proxyContactAddress2 = address.address2
            proxyContactAddress.proxyContactAddress3 = address.address3
        }
        this.setState({proxyContactAddress: proxyContactAddress}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getPaymentAddressFromZipCode(): Promise<void> {
        const paymentContactAddress = this.state.paymentContactAddress

        const address: Nullable<Address> = await this.getAddressFromZipCode(paymentContactAddress.paymentZipCode, 'paymentContactAddress.paymentZipCode')
        if (address) {
            paymentContactAddress.paymentPrefecture = address.prefecture
            paymentContactAddress.paymentAddress2 = address.address2
            paymentContactAddress.paymentAddress3 = address.address3
        }
        this.setState({paymentContactAddress: paymentContactAddress}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async getDestinationAddressFromZipCode(): Promise<void> {
        const destinationContactAddress = this.state.destinationContactAddress

        const address: Nullable<Address> = await this.getAddressFromZipCode(
            destinationContactAddress.destinationZipCode ?? null, 'destinationContactAddress.destinationZipCode')
        if (address) {
            destinationContactAddress.destinationPrefecture = address.prefecture
            destinationContactAddress.destinationAddress2 = address.address2
            destinationContactAddress.destinationAddress3 = address.address3
        }
        this.setState({destinationContactAddress: destinationContactAddress}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        if (!this.props.location.state.inputHistory?.outlineInfo) {
            return
        }
        const {residentPlace} = this.props.location.state.inputHistory.outlineInfo
        const {ownershipTransferDate} = this.props.location.state
        const {
            moveInDate, contactInformation, beforeContactAddress,
            proxyContactAddress, rentExistence, paymentExistence,
            paymentContactAddress, destinationExistence, destinationContactAddress,
        } = this.state

        let applyButtonDisabled = false

        const needBeforeContactAddress =
            (moveInDate >= moment(ownershipTransferDate).clone().add(60, 'days').format('YYYY-MM-DD'))

        if (residentPlace === RESIDENT_PLACE.RESIDING.value) {
            if (!moveInDate || !contactInformation.contactPhoneNumber || !contactInformation.contactPrefecture
                || !contactInformation.contactAddress2 || !contactInformation.contactAddress3
                || !paymentExistence || !destinationExistence)
                applyButtonDisabled = true
        }
        if (needBeforeContactAddress) {
            if (!beforeContactAddress.beforeContactPhoneNumber || !beforeContactAddress.beforeContactPrefecture ||
                !beforeContactAddress.beforeContactAddress2 || !beforeContactAddress.beforeContactAddress3)
                applyButtonDisabled = true
        }
        if (residentPlace === RESIDENT_PLACE.DOMESTIC.value) {
            if (!contactInformation.contactPhoneNumber || !contactInformation.contactPrefecture
                || !contactInformation.contactAddress2 || !contactInformation.contactAddress3
                || !rentExistence || !paymentExistence || !destinationExistence)
                applyButtonDisabled = true
        }
        if (residentPlace === RESIDENT_PLACE.FOREIGN.value) {
            if (!contactInformation.contactPhoneNumber || !proxyContactAddress.proxyContactRelationship
                || !proxyContactAddress.proxyContactFamilyName || !proxyContactAddress.proxyContactFirstName
                || !proxyContactAddress.proxyContactPhoneNumber || !proxyContactAddress.proxyContactPrefecture
                || !proxyContactAddress.proxyContactAddress2 || !proxyContactAddress.proxyContactAddress3
                || !rentExistence || !paymentExistence || !destinationExistence)
                applyButtonDisabled = true
        }

        if (paymentExistence === PAYMENT_EXISTENCE.AGENT.value) {
            if (!paymentContactAddress.paymentRelationship || !paymentContactAddress.paymentName
                || !paymentContactAddress.paymentPhoneNumber || !paymentContactAddress.paymentPrefecture
                || !paymentContactAddress.paymentAddress2 || !paymentContactAddress.paymentAddress3)
                applyButtonDisabled = true
        }

        if (destinationExistence === DESTINATION_EXISTENCE.AGENT.value) {
            if (!destinationContactAddress.destinationName || !destinationContactAddress.destinationPhoneNumber
                || !destinationContactAddress.destinationPrefecture || !destinationContactAddress.destinationAddress2
                || !destinationContactAddress.destinationAddress3)
                applyButtonDisabled = true
        }

        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    async onClickApplyConfirmButton(): Promise<void> {
        if (!this.props.location.state.inputHistory?.outlineInfo) {
            return
        }
        const {
            familyName, firstName, familyNameKana, firstNameKana,
            mailAddress, mailAddressConfirm, sharer, residentPlace,
        } = this.props.location.state.inputHistory.outlineInfo
        const {
            moveInDate, contactInformation, beforeContactAddress,
            proxyContactAddress, rentExistence, paymentExistence, paymentContactAddress,
            destinationExistence, destinationContactAddress,
        } = this.state

        let request: Nullable<NatPutNewMemberRequest> = null

        request = {
            applyId: this.props.applyId ?? null,
            familyName: familyName,
            firstName: firstName,
            familyNameKana: familyNameKana,
            firstNameKana: firstNameKana,
            mailAddress: mailAddress,
            mailAddressConfirm: mailAddressConfirm,
            sharer: sharer,
            residentPlace: residentPlace,
            moveInDate: moveInDate === '' ? null : moveInDate,
            contactInformation: contactInformation,
            beforeContactAddress: beforeContactAddress,
            proxyContactAddress: proxyContactAddress,
            rentExistence: rentExistence === '' ? null : rentExistence,
            paymentExistence: paymentExistence,
            paymentContactAddress: paymentContactAddress,
            destinationExistence: destinationExistence,
            destinationContactAddress: destinationContactAddress,
            confirmed: false,
            version: this.props.location.state.inputHistory?.detailInfo?.version ?? null,
        }

        if (!request) {
            return
        }

        await this.props.onClickApplyConfirmButton(request)
    }

    renderMoveInDate(): ReactElement {
        const {moveInDate, holidays} = this.state
        if (!this.props.location.state.inputHistory?.outlineInfo) {
            return <></>
        }
        const {residentPlace} = this.props.location.state.inputHistory?.outlineInfo
        const ownershipTransferDate = this.props.location.state.ownershipTransferDate

        if (residentPlace !== RESIDENT_PLACE.RESIDING.value) {
            return <></>
        }
        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    入居予定日
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'入居予定日'}
                        required
                        component={
                            <PPDatePickerForResident
                                date={moveInDate}
                                onChange={this.handleMoveInDate}
                                holidays={holidays}
                                itemValue={''}
                                minDate={new Date(moment(ownershipTransferDate).format('YYYY-MM-DD'))}
                                eventKeys={['moveInDate']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderContactAddress(): ReactElement {
        if (!this.props.location.state.inputHistory?.outlineInfo) {
            return <></>
        }
        const {residentPlace} = this.props.location.state.inputHistory.outlineInfo

        return (
            <>
                <Box height={'15px'}/>
                {residentPlace === RESIDENT_PLACE.RESIDING.value ?
                    <>
                        <ItemHeading>
                            入居後の連絡先
                        </ItemHeading>
                    </>
                    :
                    <>
                        <ItemHeading>
                            連絡先
                        </ItemHeading>
                    </>
                }
                {residentPlace === RESIDENT_PLACE.FOREIGN.value ?
                    <>
                        {this.renderForeignContactAddressInfo()}
                    </>
                    :
                    <>
                        {this.renderDomesticContactAddressInfo()}
                    </>
                }
            </>
        )
    }

    renderForeignContactAddressInfo(): ReactElement {
        const {contactInformation} = this.state
        const {contactPhoneNumber, contactAddress} = contactInformation

        return (
            <>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={<span>電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 11,
                                        name: 'contactInformation.contactPhoneNumber',
                                        value: contactPhoneNumber ?? '',
                                        placeholder: '例：08012345678',
                                    }}
                                    onChange={this.handleChangeContactInformationText}
                                    eventKeys={['contactInformation.contactPhoneNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'住所'}
                        component={
                            <PPTextAreaForResident
                                inputProps={{
                                    maxLength: 200,
                                    name: 'contactInformation.contactAddress',
                                    value: contactAddress ?? '',
                                }}
                                onChange={this.handleChangeContactInformationText}
                                eventKeys={['contactInformation.contactAddress']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderDomesticContactAddressInfo(): ReactElement {
        const {contactInformation} = this.state
        const {
            contactPhoneNumber, contactZipCode, contactPrefecture,
            contactAddress2, contactAddress3, contactBuildingRoomNumber,
        } = contactInformation

        return (
            <>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={<span>電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 11,
                                        name: 'contactInformation.contactPhoneNumber',
                                        value: contactPhoneNumber ?? '',
                                        placeholder: '例：08012345678',
                                    }}
                                    onChange={this.handleChangeContactInformationText}
                                    eventKeys={['contactInformation.contactPhoneNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: 'contactInformation.contactZipCode',
                                                value: contactZipCode ?? '',
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangeContactInformationText}
                                            eventKeys={['contactInformation.contactZipCode']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getContactInformationFromZipCode()}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'都道府県'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: 'contactInformation.contactPrefecture',
                                    value: contactPrefecture ?? '',
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangeContactInformationText}
                                eventKeys={['contactInformation.contactPrefecture']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'市区町村'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'contactInformation.contactAddress2',
                                    value: contactAddress2 ?? '',
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangeContactInformationText}
                                eventKeys={['contactInformation.contactAddress2']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'番地'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'contactInformation.contactAddress3',
                                    value: contactAddress3 ?? '',
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangeContactInformationText}
                                eventKeys={['contactInformation.contactAddress3']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'contactInformation.contactBuildingRoomNumber',
                                    value: contactBuildingRoomNumber ?? '',
                                    placeholder: '例：すてきマンション　１０１号室',
                                    onChange: this.handleChangeContactInformationText,
                                }}
                                onChange={this.handleChangeContactInformationText}
                                eventKeys={['contactInformation.contactBuildingRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>

        )
    }

    renderBeforeContactAddress(): ReactElement {
        const {beforeContactAddress, moveInDate} = this.state
        const {ownershipTransferDate} = this.props.location.state
        const {
            beforeContactPhoneNumber, beforeContactZipCode, beforeContactPrefecture,
            beforeContactAddress2, beforeContactAddress3, beforeContactBuildingRoomNumber,
        } = beforeContactAddress

        const needBeforeContactAddress =
            (moveInDate >= moment(ownershipTransferDate).clone().add(60, 'days').format('YYYY-MM-DD'))
        if (!needBeforeContactAddress) {
            return <></>
        }

        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    入居までの連絡先
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={<span>電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 11,
                                        name: 'beforeContactAddress.beforeContactPhoneNumber',
                                        value: beforeContactPhoneNumber ?? '',
                                        placeholder: '例：08012345678',
                                    }}
                                    onChange={this.handleChangeBeforeContactAddressText}
                                    eventKeys={['beforeContactAddress.beforeContactPhoneNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: 'beforeContactAddress.beforeContactZipCode',
                                                value: beforeContactZipCode ?? '',
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangeBeforeContactAddressText}
                                            eventKeys={['beforeContactAddress.beforeContactZipCode']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getBeforeContactAddressFromZipCode()}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'都道府県'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: 'beforeContactAddress.beforeContactPrefecture',
                                    value: beforeContactPrefecture ?? '',
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangeBeforeContactAddressText}
                                eventKeys={['beforeContactAddress.beforeContactPrefecture']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'市区町村'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'beforeContactAddress.beforeContactAddress2',
                                    value: beforeContactAddress2 ?? '',
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangeBeforeContactAddressText}
                                eventKeys={['beforeContactAddress.beforeContactAddress2']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'番地'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'beforeContactAddress.beforeContactAddress3',
                                    value: beforeContactAddress3 ?? '',
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangeBeforeContactAddressText}
                                eventKeys={['beforeContactAddress.beforeContactAddress3']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'beforeContactAddress.beforeContactBuildingRoomNumber',
                                    value: beforeContactBuildingRoomNumber ?? '',
                                    placeholder: '例：すてきマンション　１０１号室',
                                    onChange: this.handleChangeBeforeContactAddressText,
                                }}
                                onChange={this.handleChangeBeforeContactAddressText}
                                eventKeys={['beforeContactAddress.beforeContactBuildingRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderProxyContactAddress(): ReactElement {
        if (!this.props.location.state.inputHistory?.outlineInfo) {
            return <></>
        }
        const {residentPlace} = this.props.location.state.inputHistory.outlineInfo
        const {proxyContactAddress} = this.state
        const {
            proxyContactRelationship, proxyContactFamilyName, proxyContactFirstName,
            proxyContactPhoneNumber, proxyContactZipCode, proxyContactPrefecture,
            proxyContactAddress2, proxyContactAddress3, proxyContactBuildingRoomNumber,
        } = proxyContactAddress

        if (residentPlace !== RESIDENT_PLACE.FOREIGN.value) {
            return <></>
        }

        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    国内の代理連絡先
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'組合員との関係性'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 15,
                                    name: 'proxyContactAddress.proxyContactRelationship',
                                    value: proxyContactRelationship ?? '',
                                    placeholder: '例：夫、妻、子など',
                                }}
                                onChange={this.handleChangeProxyContactAddressText}
                                eventKeys={['proxyContactAddress.proxyContactRelationship']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'proxyContactAddress.proxyContactFamilyName',
                                        maxLength: 10,
                                        value: proxyContactFamilyName ?? '',
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeProxyContactAddressText}
                                    eventKeys={['proxyContactAddress.proxyContactFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'proxyContactAddress.proxyContactFirstName',
                                        maxLength: 10,
                                        value: proxyContactFirstName ?? '',
                                        placeholder: '例：太郎',
                                    }}
                                    onChange={this.handleChangeProxyContactAddressText}
                                    eventKeys={['proxyContactAddress.proxyContactFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={<span>電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 11,
                                        name: 'proxyContactAddress.proxyContactPhoneNumber',
                                        value: proxyContactPhoneNumber ?? '',
                                        placeholder: '例：08012345678',
                                    }}
                                    onChange={this.handleChangeProxyContactAddressText}
                                    eventKeys={['proxyContactAddress.proxyContactPhoneNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: 'proxyContactAddress.proxyContactZipCode',
                                                value: proxyContactZipCode ?? '',
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangeProxyContactAddressText}
                                            eventKeys={['proxyContactAddress.proxyContactZipCode']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getProxyContactAddressFromZipCode()}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'都道府県'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: 'proxyContactAddress.proxyContactPrefecture',
                                    value: proxyContactPrefecture ?? '',
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangeProxyContactAddressText}
                                eventKeys={['proxyContactAddress.proxyContactPrefecture']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'市区町村'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'proxyContactAddress.proxyContactAddress2',
                                    value: proxyContactAddress2 ?? '',
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangeProxyContactAddressText}
                                eventKeys={['proxyContactAddress.proxyContactAddress2']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'番地'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'proxyContactAddress.proxyContactAddress3',
                                    value: proxyContactAddress3 ?? '',
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangeProxyContactAddressText}
                                eventKeys={['proxyContactAddress.proxyContactAddress3']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'proxyContactAddress.proxyContactBuildingRoomNumber',
                                    value: proxyContactBuildingRoomNumber ?? '',
                                    placeholder: '例：すてきマンション　１０１号室',
                                    onChange: this.handleChangeProxyContactAddressText,
                                }}
                                onChange={this.handleChangeProxyContactAddressText}
                                eventKeys={['proxyContactAddress.proxyContactBuildingRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderRentExistence(): ReactElement {
        if (!this.props.location.state.inputHistory?.outlineInfo) {
            return <></>
        }
        const {residentPlace} = this.props.location.state.inputHistory.outlineInfo
        const {rentExistence} = this.state

        if (residentPlace === RESIDENT_PLACE.RESIDING.value) {
            return <></>
        }

        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    賃貸
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <DisplayItemInputTitleRequiredNoMargin>
                        賃貸の有無
                    </DisplayItemInputTitleRequiredNoMargin>
                    <Box height={'10px'}/>
                    <PPRadioGroupForGuest
                        data={RENT_EXISTENCE.values()}
                        selectValue={rentExistence}
                        onChange={this.handleChangeRentExistence}
                        eventKeys={['rentExistence']}
                        eventEmitter={this.props.eventEmitter}
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderPaymentExistence(): ReactElement {
        const {paymentExistence} = this.state

        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    管理費等の支払情報
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <DisplayItemInputTitleRequiredNoMargin>
                        管理費等の支払者
                    </DisplayItemInputTitleRequiredNoMargin>
                    <Box height={'10px'}/>
                    <PPRadioGroupForGuest
                        data={PAYMENT_EXISTENCE.values()}
                        selectValue={paymentExistence}
                        onChange={this.handleChangePaymentExistence}
                        eventKeys={['paymentExistence']}
                        eventEmitter={this.props.eventEmitter}
                    />
                    <Box height={'10px'}/>
                    <Box fontSize={FontSize.Middle}>
                        <div>※本人以外の支払いを認めていない管理組合がございます。管理規約をご確認ください。</div>
                    </Box>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderPaymentContactAddress(): ReactElement {
        const {paymentContactAddress, paymentExistence} = this.state
        const {
            paymentRelationship, paymentName, paymentPhoneNumber, paymentZipCode, paymentPrefecture,
            paymentAddress2, paymentAddress3, paymentBuildingRoomNumber,
        } = paymentContactAddress

        if (paymentExistence !== PAYMENT_EXISTENCE.AGENT.value) {
            return <></>
        }

        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    支払者情報
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'組合員との関係性'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 15,
                                    name: 'paymentContactAddress.paymentRelationship',
                                    value: paymentRelationship ?? '',
                                    placeholder: '例：夫、妻、子など',
                                }}
                                onChange={this.handleChangePaymentAddressText}
                                eventKeys={['paymentContactAddress.paymentRelationship']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'氏名または法人名'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'paymentContactAddress.paymentName',
                                    value: paymentName ?? '',
                                    placeholder: '例：素敵 太郎',
                                }}
                                onChange={this.handleChangePaymentAddressText}
                                eventKeys={['paymentContactAddress.paymentName']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={<span>電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 11,
                                        name: 'paymentContactAddress.paymentPhoneNumber',
                                        value: paymentPhoneNumber ?? '',
                                        placeholder: '例：08012345678',
                                    }}
                                    onChange={this.handleChangePaymentAddressText}
                                    eventKeys={['paymentContactAddress.paymentPhoneNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: 'paymentContactAddress.paymentZipCode',
                                                value: paymentZipCode ?? '',
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangePaymentAddressText}
                                            eventKeys={['paymentContactAddress.paymentZipCode']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getPaymentAddressFromZipCode()}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'都道府県'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: 'paymentContactAddress.paymentPrefecture',
                                    value: paymentPrefecture ?? '',
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangePaymentAddressText}
                                eventKeys={['paymentContactAddress.paymentPrefecture']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'市区町村'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'paymentContactAddress.paymentAddress2',
                                    value: paymentAddress2 ?? '',
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangePaymentAddressText}
                                eventKeys={['paymentContactAddress.paymentAddress2']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'番地'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'paymentContactAddress.paymentAddress3',
                                    value: paymentAddress3 ?? '',
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangePaymentAddressText}
                                eventKeys={['paymentContactAddress.paymentAddress3']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'paymentContactAddress.paymentBuildingRoomNumber',
                                    value: paymentBuildingRoomNumber ?? '',
                                    placeholder: '例：すてきマンション　１０１号室',
                                    onChange: this.handleChangePaymentAddressText,
                                }}
                                onChange={this.handleChangePaymentAddressText}
                                eventKeys={['paymentContactAddress.paymentBuildingRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderDestinationExistence(): ReactElement {
        const {destinationExistence} = this.state

        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    請求書の送付先情報
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <DisplayItemInputTitleRequiredNoMargin>
                        請求書の送付先
                    </DisplayItemInputTitleRequiredNoMargin>
                    <Box height={'10px'}/>
                    <PPRadioGroupForGuest
                        data={DESTINATION_EXISTENCE.values()}
                        selectValue={destinationExistence}
                        onChange={this.handleChangeDestinationExistence}
                        eventKeys={['destinationExistence']}
                        eventEmitter={this.props.eventEmitter}
                    />
                    <Box height={'10px'}/>
                    <Box fontSize={FontSize.Middle}>
                        <div>※請求書は管理費等に金額変更や未納が発生した場合に送付させていただく場合がございます。</div>
                    </Box>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderDestinationContactAddress(): ReactElement {
        const {destinationContactAddress, destinationExistence} = this.state
        const {
            destinationName, destinationPhoneNumber, destinationZipCode, destinationPrefecture,
            destinationAddress2, destinationAddress3, destinationBuildingRoomNumber,
        } = destinationContactAddress

        if (destinationExistence !== DESTINATION_EXISTENCE.AGENT.value) {
            return <></>
        }

        return (
            <>
                <Box height={'15px'}/>
                <ItemHeading>
                    送付先情報
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'氏名または法人名'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'destinationContactAddress.destinationName',
                                    value: destinationName ?? '',
                                    placeholder: '例：素敵 太郎',
                                }}
                                onChange={this.handleChangeDestinationAddressText}
                                eventKeys={['destinationContactAddress.destinationName']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={<span>電話番号<BreakPcOnly/>（ハイフン不要）</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 11,
                                        name: 'destinationContactAddress.destinationPhoneNumber',
                                        value: destinationPhoneNumber ?? '',
                                        placeholder: '例：08012345678',
                                    }}
                                    onChange={this.handleChangeDestinationAddressText}
                                    eventKeys={['destinationContactAddress.destinationPhoneNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'郵便番号（ハイフン不要）'}
                        component={
                            <ErrorMessageAreaWrapper>
                                <FlexContainer>
                                    <Box flex={2} minWidth={0}>
                                        <PPTextFieldForResident
                                            inputProps={{
                                                maxLength: 7,
                                                name: 'destinationContactAddress.destinationZipCode',
                                                value: destinationZipCode ?? '',
                                                placeholder: '例：1234567',
                                            }}
                                            onChange={this.handleChangeDestinationAddressText}
                                            eventKeys={['destinationContactAddress.destinationZipCode']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </Box>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <Box flex={1} maxWidth={'160px'} minWidth={'125px'} maxHeight={'50px'}>
                                        <DefaultStyledButton
                                            onClick={() => this.getDestinationAddressFromZipCode()}>
                                            住所自動入力
                                        </DefaultStyledButton>
                                    </Box>
                                </FlexContainer>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'都道府県'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 4,
                                    name: 'destinationContactAddress.destinationPrefecture',
                                    value: destinationPrefecture ?? '',
                                    placeholder: '例：東京都',
                                }}
                                onChange={this.handleChangeDestinationAddressText}
                                eventKeys={['destinationContactAddress.destinationPrefecture']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'市区町村'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'destinationContactAddress.destinationAddress2',
                                    value: destinationAddress2 ?? '',
                                    placeholder: '例：港区',
                                }}
                                onChange={this.handleChangeDestinationAddressText}
                                eventKeys={['destinationContactAddress.destinationAddress2']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'番地'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'destinationContactAddress.destinationAddress3',
                                    value: destinationAddress3 ?? '',
                                    placeholder: '例：芝４－６－６',
                                }}
                                onChange={this.handleChangeDestinationAddressText}
                                eventKeys={['destinationContactAddress.destinationAddress3']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'建物名・部屋番号'}
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 50,
                                    name: 'destinationContactAddress.destinationBuildingRoomNumber',
                                    value: destinationBuildingRoomNumber ?? '',
                                    placeholder: '例：すてきマンション　１０１号室',
                                    onChange: this.handleChangeDestinationAddressText,
                                }}
                                onChange={this.handleChangeDestinationAddressText}
                                eventKeys={['destinationContactAddress.destinationBuildingRoomNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return <></>
        }

        const {submitButtonLabel} = this.props
        const {applyButtonDisabled} = this.state

        return (
            <>
                {this.renderMoveInDate()}
                {this.renderBeforeContactAddress()}
                {this.renderContactAddress()}
                {this.renderProxyContactAddress()}
                {this.renderRentExistence()}
                {this.renderPaymentExistence()}
                {this.renderPaymentContactAddress()}
                {this.renderDestinationExistence()}
                {this.renderDestinationContactAddress()}
                <Box height={'20px'}/>
                <GuestApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </GuestApplyButton>
            </>
        )
    }
}

const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`
